// @copyright  2006 - 2022 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'billing.page.title': 'Billing',
    'subscription-invoice.page.title': 'Billing and Payments',
    'subscription-invoice.page.update-payment-method-title': 'Update Payment Method',

    'subscription-invoice.button.view-subscription': 'View Subscription',
    'subscription-invoice.button.update-payment-method': 'Update Payment Method',
    'subscription-invoice.button.search_invoices': 'View Invoices',

    'tenant.label.current_card': 'Current Payment Method',
    'tenant.label.update_card': 'New Payment Method',

    'subscription-invoice.message.update-payment-method-success': 'Payment method updated successfully',

    'subscription-invoice.button.change_plan': 'Change Plan',
    'subscription-invoice.button.cancel_subscription': 'Cancel Subscription',
    'subscription-invoice.button.delete_account': 'Delete Account',

    'subscription-invoice.modal.title.cancel_subscription': 'Cancel Subscription',
    'subscription-invoice.modal.message.cancel_subscription': 'Are you sure you want to cancel your subscription?',
    'subscription-invoice.modal.title.delete_account': 'Delete Account',
    'subscription-invoice.modal.message.delete_account': "Are you sure you want to PERMANENTLY delete your account? This can't be undone.",

    'subscription-invoice.error.message': 'Sorry, unable to process this card.',
};
